import { Skeleton, Spin } from 'antd';

import * as St from './SkeletonCardColor.styles';

const SkeletonCardColor = () => (
  <St.Container className="skeleton">
    <Skeleton.Node active rootClassName={St.imgClassName}>
      <Spin />
    </Skeleton.Node>
    {['30%', '50%', '75%'].map((width) => (
      <div key={`skel-color--line-${width}`} style={{ width }}>
        <Skeleton.Input active block rootClassName={St.lineClassName} />
      </div>
    ))}
  </St.Container>
);

export default SkeletonCardColor;
